module.exports = __webpack_public_path__ + "static/gather-grapes-78a2e6b24e2a08c9fd842fac512ed961.png";